import camelCaseKeys from 'camelcase-keys'

export class Address {
  constructor (params = {}) {
    const {
      line1,
      line2,
      city,
      postalCode,
      region,
      countryCode
    } = camelCaseKeys(params, { deep: true })
    this.line1 = line1 || null
    this.line2 = line2 || null
    this.city = city || null
    this.postalCode = postalCode || null
    this.region = region || null
    this.countryCode = countryCode || null
  }
}
